import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { dynamicUrl } from '../Function';
import { useDynamicLink } from '../DynamicUse';
import { Container,Image,Card,Placeholder,Button } from 'react-bootstrap';
import Slider from "react-slick";
import '../focusUtils';
const HpAwards = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const MorePage = useDynamicLink(192);    
    const[isLoading, setLoading] = useState(true);
    const[Achievements,setAchievements]=useState([]);
    useEffect(()=>
    {
        const StickyAchievements = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"achievements/sticky");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sa_id + "/achievementImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sa_id + "/achievementImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].achievementImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].achievementImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setAchievements(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Achievements Image :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setAchievements([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true )
                {
                    console.info('Achievements : Result',result);
                }
              
            } catch (error) 
            {
                console.error('Achievements : Error', error.message);
                setLoading(false);
            }
        };
        StickyAchievements();
        window.disableFocusInHiddenSlides();
        window.enableFocusInVisibleSlides();  
    },[])
    const settings = {
        autoplay: true,
        centerMode: false,
        infinite: true,
        centerPadding: "0px",
        dots: false,
        slidesToShow: 3,
        speed: 500,
        accessibility: true,
        beforeChange: (current, next) => { window.disableFocusInHiddenSlides(); },
        afterChange: current => { window.enableFocusInVisibleSlides(); },
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 2 }}, { breakpoint: 768,settings: { slidesToShow: 1 }} ]
      };
    return (
        <section className="hp-awards bg-info-subtle">
            <Container className="py-5 text-center">
                <div className='d-flex align-items-center justify-content-center mb-4'>
                    <Image src={global.config.uploadPath+'942937147.png'} alt={appLanguage === 'hi' ? 'बायाँ ग्राफ़िक्स' : 'Left Graphics'} loading="lazy" fluid data-aos="fade-left" data-aos-duration="1500" />
                    <div className='mx-3' data-aos="flip-up" data-aos-duration="1500">
                        <h2 className='text-dark'>{t('AwardsAchievements')}</h2>
                        <span className="sub-heading"></span>
                    </div>
                    <Image src={global.config.uploadPath+'1134741036.png'} alt={appLanguage === 'hi' ? 'दाया ग्राफ़िक्स' : 'Right Graphics'} loading="lazy" fluid data-aos="fade-right" data-aos-duration="1500" />
                </div>
                {isLoading ? (
                <div className="slider-container px-4 py-3" data-aos="fade-up" data-aos-duration="1500">
                    <Slider {...settings}>
                        {[...Array(5)].map((_,index)=>(
                        <div className='p-3' key={index}>
                            <Card className='text-center card-custom rounded-3 p-3'>
                                <Placeholder xs={12} className="card-img-top border rounded-0" style={{minHeight:"250px"}} />
                                <Card.Body className='p-0 rounded-bottom'>
                                    <Placeholder xs={10} />
                                </Card.Body>
                                <Card.Footer className='rounded-top text-bg-dark bg-opacity-75'>
                                    <Placeholder xs={10} />
                                    <Button className='btn btn-info w-50'><Placeholder xs={12} /></Button>
                                </Card.Footer>
                            </Card>
                        </div>
                        ))}
                    </Slider>
                </div>
                ) : (
                <div className="slider-container px-4 py-3" data-aos="fade-up" data-aos-duration="1500">
                    <Slider {...settings}>
                        {Achievements.map((sa, index)=>(
                            <div className='p-3' key={index}>
                                <Card className='text-center card-custom rounded-3 p-3'>
                                    {appLanguage === 'hi' ? 
                                        (
                                            sa.achievementImageHi 
                                            ? <Card.Img variant="top" className="img-fluid border rounded-0" src={sa.achievementImageHi} alt={`${sa.sa_name_hi} पुरस्कार`} width={350} height={250} loading="lazy" /> 
                                            : sa.achievementImage
                                                ? <Card.Img variant="top" className="img-fluid border rounded-0" src={sa.achievementImage} width={350} height={250} alt={`${sa.sa_name_hi} पुरस्कार`} loading="lazy" /> 
                                                : <Placeholder xs={12} className="card-img-top img-fluid border rounded-0" width={350} height={250} />
                                        ) : (
                                            sa.achievementImage
                                            ? <Card.Img variant="top" className="img-fluid border rounded-0" src={sa.achievementImage} width={350} height={250} alt={`${sa.sa_name} award`} loading="lazy" /> 
                                            : <Placeholder xs={12} className="card-img-top img-fluid border rounded-0" width={350} height={250} />
                                        )
                                    }
                                    <Card.Body className='p-0 rounded-bottom fw-bold'>
                                        <Card.Title className='fs-6 mb-0' dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? sa.sa_name_hi || sa.sa_name : sa.sa_name}} />
                                    </Card.Body>
                                    <Card.Footer className='rounded-top text-bg-dark bg-opacity-75'>
                                        <div dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? sa.sa_description_hi || sa.sa_description : sa.sa_description}}></div>
                                        <NavLink to={appLanguage === 'hi' ? `/उपलब्धि/विवरण/${sa.sa_htaccess_hi || sa.sa_htaccess}` : `/achievement/details/${sa.sa_htaccess}`} className='btn btn-info' aria-label={appLanguage === 'hi' ? sa.sa_name_hi || sa.sa_name : sa.sa_name} target='_blank' rel="noopener noreferrer">
                                            {t('ReadMore')} <i className="bi bi-arrow-right-short"></i>
                                        </NavLink>
                                    </Card.Footer>
                                </Card>
                            </div>
                        ))}
                    </Slider>
                </div>
                )}
                {MorePage && MorePage.map((sp,index)=>(
                    <NavLink key={index} to={dynamicUrl(sp)} className="btn btn-lg btn-info" data-aos="flip-up" data-aos-duration="1000">
                        {t('ReadMore')} <i className="bi bi-arrow-right-short"></i>
                    </NavLink>
                ))}
            </Container>
        </section>
    );
    
}
export default HpAwards;